@if (componentData.data$ | async; as component) {
  <div
    class="content-header"
    [ngClass]="{ 'content-header--with-image': component.media }"
  >
    <boels-media
      class="content-header__img"
      [container]="component.media"
      [alt]="component.imageAltText ? component.imageAltText : ''"
      [loading]="lazy"
    ></boels-media>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <span class="h4 content-header__page-type">{{
            component.pageType
          }}</span>
          <span class="h1 content-header__title">{{ component.title }}</span>
          <div class="scroll-arrow bounce">
            <button class="btn-scroll-arrow" (click)="scroll(target)">
              <fa-icon [icon]="faChevronDown" class="large"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    #target
    [ngClass]="{ 'content-header__bottom': !component.removeBottomSpacing }"
  ></div>
}
